import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  mostrarChatbot,
  ocultarChatbot,
  setPregunta,
  enviarPregunta,
  resetRespuesta
} from '../../reducers/chatbotBubble_slice';
import './chatbotBubble.css';

const ChatbotBubble = ({ id_afiliado }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { visible, pregunta, respuesta, status } = useSelector(state => state.chatbotBubble);
  const chatBoxRef = useRef(null);

  useEffect(() => {
    dispatch(ocultarChatbot());
  }, [location.pathname, dispatch]);

  const handleEnviar = () => {
    if (pregunta.trim() !== '') {
      dispatch(enviarPregunta({ pregunta, id_afiliado }));
      dispatch(setPregunta('')); // Limpiar campo después de enviar
    }
  };

  const formatearRespuesta = (texto) => {
    const conNegrillas = texto.replace(/\*([^*]+)\*/g, '<strong>$1</strong>');
    return { __html: conNegrillas };
  };

  return (
    <div className="chatbot-container">
      {!visible && (
        <button className="chatbot-toggle-button" onClick={() => dispatch(mostrarChatbot())}>
          💬
        </button>
      )}

      {visible && (
        <div className="chatbot-box" ref={chatBoxRef}>
          <div className="chatbot-header">
            <span>Asistente CAT</span>
            <button onClick={() => dispatch(ocultarChatbot())}>✖️</button>
          </div>

          <div className="chatbot-body">
            <div className="respuesta-area">
              {status === 'loading' ? (
                <div className="mensaje-cargando">Pensando...</div>
              ) : (
                <div
                  className="mensaje-respuesta"
                  dangerouslySetInnerHTML={formatearRespuesta(respuesta)}
                ></div>
              )}
            </div>
          </div>

          <div className="chatbot-input">
            <textarea
              placeholder="Escribe tu pregunta..."
              value={pregunta}
              onChange={(e) => dispatch(setPregunta(e.target.value))}
              onKeyDown={(e) => e.key === 'Enter' && !e.shiftKey && handleEnviar()}
              rows={1}
              className="chatbot-textarea"
            />
            <button onClick={handleEnviar}>Enviar</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatbotBubble;
